"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var vc_config_base_exports = {};
__export(vc_config_base_exports, {
  serverlessVercelNodeJsConfig: () => serverlessVercelNodeJsConfig
});
module.exports = __toCommonJS(vc_config_base_exports);
var serverlessVercelNodeJsConfig = {
  environment: {},
  runtime: "nodejs20.x",
  handler: "entrypoint/index.js",
  launcherType: "Nodejs",
  shouldAddHelpers: true,
  shouldAddSourceMapSupport: true
};
//# sourceMappingURL=vc-config-base.js.map
